import { UTCDeliveryPeriod } from '@epicuro-next/ataraxia/models';
import { ExtendedBasketAccountAddress } from '@epicuro-next/state/basket-state';
import { createAction, props } from '@ngrx/store';
import { OrderType } from 'graphql-api/gql-api-interfaces';

import {
  BulkTypeDeliveryPeriod,
  DeliveryPeriodsByShop,
  DeliveryPeriodType,
} from '../models';
import { DeliveryPeriodsCache } from '../models/delivery-periods-cache.model';

// meaning that user clicked on it (similar to DOM events fired)
export type isTrustedDeliveryPeriod = { isTrusted?: boolean };

export const executeDeliveryPeriodSelectionAction = createAction(
  '[Config Strip][Delivery Periods] Run delivery period selection logic',
);

/**
 * NOW
 */
export const selectNowDeliveryPeriod = createAction(
  '[Config Strip][Delivery Periods] Select NOW Delivery Period',
);

export const preSelectNowDeliveryPeriod = createAction(
  '[Config Strip][Delivery Periods] Pre-Select NOW Delivery Period',
);

export const preSelectAnyDeliveryPeriod = createAction(
  '[Config Strip][Delivery Periods] Pre-Select ANY Delivery Period',
);

/**
 * FUTURE
 */
export const initCalculationFutureDeliveryPeriodsFromInventories = createAction(
  '[Config Strip][Delivery Periods] Init Future Delivery Period calculation from Inventories',
);

// just a trigger to load cache
export const initCachedDeliveryPeriods = createAction(
  '[Config Strip][Delivery Periods] Init Delivery Periods From Cache',
);

export const copyFromCacheDeliveryPeriods = createAction(
  '[Config Strip][Delivery Periods] Copy Delivery Periods From Cache',
  props<DeliveryPeriodsCache>(),
);

export const setUnavailableDeliveryPeriods = createAction(
  '[Config Strip][Delivery Periods] Set Unavailable Future Delivery Period',
  props<{ deliveryPeriods: string[] }>(),
);

export const selectFutureDeliveryPeriod = createAction(
  '[Config Strip][Delivery Periods] Select Future Delivery Period',
  props<{
    deliveryPeriod: UTCDeliveryPeriod & isTrustedDeliveryPeriod;
  }>(),
);

export const preSelectFutureDeliveryPeriod = createAction(
  '[Config Strip][Delivery Periods] Pre-Select Future Delivery Period',
  // null for cases ONLY when  you now you want to select first available future
  // if there is such or open calendar, so user can select future date right away
  // if there is no available neither to be copied from: deliveryItems nor cachedPeriods
  props<UTCDeliveryPeriod | { from: null }>(),
);

/** Create and use new interface like bulk order delivery periods  */
export const addDeliveryPeriod = createAction(
  '[Config Strip] Add Delivery Period',
  props<{
    deliveryPeriod: UTCDeliveryPeriod & isTrustedDeliveryPeriod;
    deliveryShops: ExtendedBasketAccountAddress[];
  }>(),
);

export const addAutoDeliveryPeriod = createAction(
  '[Config Strip] Add Automatically Created Delivery Period',
  props<{
    deliveryPeriod: UTCDeliveryPeriod & isTrustedDeliveryPeriod;
    deliveryShops: ExtendedBasketAccountAddress[];
  }>(),
);

export const addAutoDeliveryPeriodSuccess = createAction(
  '[Config Strip] Add Automatically Created Delivery Period Success',
);

export const addNowDeliveryPeriod = createAction(
  '[Config Strip] Add NOW Delivery Period',
  props<{
    deliveryPeriod: UTCDeliveryPeriod & isTrustedDeliveryPeriod;
    deliveryShops: ExtendedBasketAccountAddress[];
  }>(),
);

/** Create and use new interface like bulk order delivery periods  */
export const deleteDeliveryPeriod = createAction(
  '[Config Strip] Delete Delivery Period',
  props<{ deliveryPeriod: UTCDeliveryPeriod; deliveryShopKey: string }>(),
);

export const openFutureDatepicker = createAction(
  '[Config Strip] Open Future Datepicker',
);

export const futureDeliveryPeriodsComponentInitialized = createAction(
  '[Config Strip] Future Delivery Periods component initialized',
);

/**
 * BULK
 */
export const addBulkDeliveryPeriod = createAction(
  '[Config Strip][Delivery Periods] Add Bulk Delivery Period',
  props<{
    deliveryPeriod: UTCDeliveryPeriod & isTrustedDeliveryPeriod;
    deliveryShops: ExtendedBasketAccountAddress[];
  }>(),
);

export const deleteBulkDeliveryPeriod = createAction(
  '[Config Strip][Delivery Periods] Delete Bulk Delivery Period',
  props<UTCDeliveryPeriod>(),
);

export const selectBulkDeliveryPeriod = createAction(
  '[Config Strip][Delivery Periods] Select Bulk Delivery Period',
  props<UTCDeliveryPeriod>(),
);

export const preSelectBulkDeliveryPeriod = createAction(
  '[Config Strip][Delivery Periods] Pre-Select Bulk Delivery Period',
  props<UTCDeliveryPeriod>(),
);

export const setPreselectedDeliveryPeriod = createAction(
  '[Config Strip][Delivery Periods] Set Pre-Select any Delivery Period',
  props<{
    deliveryPeriods: DeliveryPeriodsByShop;
    deliveryShops: ExtendedBasketAccountAddress[];
    preSelectedDeliveryPeriodType: DeliveryPeriodType | null;
    preSelectedDeliveryPeriod: string | BulkTypeDeliveryPeriod | null;
    preSelectedOrderType: OrderType | null;
  }>(),
);
